import React, { createContext, useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

interface NavigationHistoryContextType {
  previousPage: string | null;
  navigateBack: () => void;
}

const NavigationHistoryContext = createContext<NavigationHistoryContextType | null>(
  null,
);

export const useNavigationHistory = () => {
  const context = useContext(NavigationHistoryContext);
  if (!context) {
    throw new Error(
      'useNavigationHistory must be used within a NavigationHistoryProvider',
    );
  }
  return context;
};

interface NavigationHistoryProviderProps {
  children: React.ReactNode;
}

export const NavigationHistoryProvider: React.FC<NavigationHistoryProviderProps> = ({
  children,
}) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [previousPage, setPreviousPage] = useState<string | null>(null);

  useEffect(() => {
    if (pathname && !pathname.includes('search')) {
      setPreviousPage(pathname);
    }
  }, [pathname]);

  const navigateBack = () => {
    if (previousPage) {
      navigate(previousPage);
    } else {
      navigate('/');
    }
  };

  return (
    <NavigationHistoryContext.Provider value={{ previousPage, navigateBack }}>
      {children}
    </NavigationHistoryContext.Provider>
  );
};
